import React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import AppLogo from '../../../assets/icons/iconShanenLi.svg';

// Styled Components - All styles concentrated at the top
const SidebarHeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded: boolean }>(({ expanded, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: expanded ? 'space-between' : 'center',
  padding: theme.spacing(1.5),
  borderBottom: '1px solid rgba(255,255,255,0.2)',
  minHeight: 56,
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

const LogoButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  marginInlineEnd: theme.spacing(1.5),
  backgroundColor: 'rgba(255,255,255,0.1)',
  borderRadius: theme.spacing(2),
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.2)',
  },
}));

const LogoImage = styled('img')(({ theme }) => ({
  width: '40px',
  height: '40px',
  display: 'block',
  borderRadius: '50%',
  clipPath: 'circle(50%)',
  objectFit: 'cover',
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
}));

const ToggleButton = styled(IconButton)(({ theme }) => ({
  color: 'white',
  backgroundColor: 'rgba(255,255,255,0.1)',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.2)',
  },
}));

interface SidebarHeaderProps {
  expanded: boolean;
  onToggle: () => void;
  onLogoClick: () => void;
  title: string;
  isRtl: boolean;
  t: (key: string) => string;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ 
  expanded, 
  onToggle, 
  onLogoClick, 
  title, 
  isRtl, 
  t 
}) => {
  return (
    <SidebarHeaderContainer expanded={expanded}>
      {expanded && (
        <LogoContainer>
          <Tooltip title={t('backToApp')} placement={"bottom"}>
            <LogoButton onClick={onLogoClick}>
              <LogoImage 
                src={AppLogo} 
                alt="Logo" 
                style={{ 
                  borderRadius: '50%', 
                  clipPath: 'circle(50%)'
                }}
              />
            </LogoButton>
          </Tooltip>
          <TitleTypography variant="h6">
            {title}
          </TitleTypography>
        </LogoContainer>
      )}

      <ToggleButton onClick={onToggle} aria-label={expanded ? 'צמצם את התפריט הצדדי' : 'הרחב את התפריט הצדדי'}>
        {isRtl 
          ? (expanded ? <ChevronLeft /> : <ChevronRight />) 
          : (expanded ? <ChevronRight /> : <ChevronLeft />)
        }
      </ToggleButton>
    </SidebarHeaderContainer>
  );
};

export default SidebarHeader;